import { render, staticRenderFns } from "./DepositoDisplay.vue?vue&type=template&id=e3866ddc&scoped=true&"
import script from "./DepositoDisplay.vue?vue&type=script&lang=js&"
export * from "./DepositoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DepositoDisplay.vue?vue&type=style&index=0&id=e3866ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3866ddc",
  null
  
)

export default component.exports